module.exports = __webpack_public_path__ + "static/media/IMG_5229.8faad61b.JPG";